import { Navigate, useLocation, useParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useStorePath } from "@hooks/useStorePath";
import { WEBSITE_URL } from "@lib/firebase";
import LoadingScreen from "@/components/LoadingScreen";

/**
 * Sends bare or legacy URLs to the handle-scoped equivalent.
 *
 *   /                       -> /store/<handle>/home
 *   /admin/orders/123       -> /store/<handle>/orders/123
 *
 * The handle only exists once the business documents have loaded, so this waits
 * rather than routing to /store/undefined/... and then correcting itself.
 */
export default function StoreRedirect({ to = "home", fromLegacyAdmin = false }) {
  const { user, loading } = useAuth();
  const { storeHandle, storePath } = useStorePath();
  const location = useLocation();
  const params = useParams();

  if (loading || (user && !storeHandle)) {
    return <LoadingScreen />;
  }

  if (!user) {
    window.location.replace(`${WEBSITE_URL}/login`);
    return <LoadingScreen message="Redirecting to sign in..." />;
  }

  // Carry the rest of a legacy /admin/* URL across, so old bookmarks and any
  // links still in the wild land on the same page rather than the dashboard root.
  const target = fromLegacyAdmin ? params["*"] || to : to;

  return <Navigate to={`${storePath(target)}${location.search}`} replace />;
}
